import { render, staticRenderFns } from "./PatientFormModal.vue?vue&type=template&id=265d5611&"
import script from "./PatientFormModal.vue?vue&type=script&lang=js&"
export * from "./PatientFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports